/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LaborCostDtoPage } from '../../models/labor-cost-dto-page';

export interface ListLaborCosts$Params {
  userId?: string | null;
  projectId?: string | null;
  query?: string;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'name' | '-name' | 'isActive' | '-isActive' | 'usersCount' | '-usersCount' | 'projectsCount' | '-projectsCount' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt' | 'laborCostRates' | '-laborCostRates' | 'laborCostLogsCount' | '-laborCostLogsCount'>;
}

export function listLaborCosts(http: HttpClient, rootUrl: string, params?: ListLaborCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborCostDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listLaborCosts.PATH, 'get');
  if (params) {
    rb.query('userId', params.userId, {});
    rb.query('projectId', params.projectId, {});
    rb.query('query', params.query, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LaborCostDtoPage>;
    })
  );
}

listLaborCosts.PATH = '/v0/laborCosts';
